module.exports = __webpack_public_path__ + "img/uetsIco.356eda61.png";